import React from "react";
import "./Card.scss";

const Card = ({
  titleText,
  contentInCard,
  percentageContent,
  setMarginTop,
}) => {
  const percentage = percentageContent;

  // Check if the screen width is smaller than 768px and setMarginTop is true
  const marginTop = setMarginTop && window.innerWidth < 768 ? "10px" : "0px";

  return (
    <div className="card-component">
      <div className="card" style={{ marginTop }}>
        <div className="content">
          <div className="circleContainer">
            <svg className="svg" viewBox="0 0 36 36">
              <path
                className="circleBg"
                d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
              <path
                className="circle"
                style={{ strokeDasharray: `${percentage}, 100` }}
                d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
              />
            </svg>
            <div className="percentage">{`${percentage}%`}</div>
          </div>
        </div>
        <div className="card-text-container">
          <h3 className="title">{titleText}</h3>
          <p className="tasks">{contentInCard}</p>
        </div>
      </div>
    </div>
  );
};

export default Card;
